import { render, staticRenderFns } from "./pic-cell.vue?vue&type=template&id=6d958ae2&scoped=true"
import script from "./pic-cell.vue?vue&type=script&lang=js"
export * from "./pic-cell.vue?vue&type=script&lang=js"
import style0 from "./pic-cell.vue?vue&type=style&index=0&id=6d958ae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d958ae2",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/practice/company/pic-cell.vue
// module id = null
// module chunks = 